import React from 'react'
import './calendars.scss'
import Calendar from './Calendar/Calendar'

const Calendars = () => {
	return (
		<div className="calendars">
			<Calendar />
		</div>
	)
}

export default Calendars
